<div class="">
  <!-- title -->
  <ng-container>
    <app-modal-title
      [isShowClose]="true"
      (isCloseModal)="onClose()"
      [title]="'common.tableSetting' | translate"
    ></app-modal-title>
  </ng-container>

  <div mat-dialog-content class="tw-p-4">
    <div class="tw-py-4 tw-px-3">
      <input
        id="selectAll"
        type="checkbox"
        class="form-check-input tw-ml-2"
        [checked]="selectAll"
        (change)="toggleSelectAll($event)"
      />
      <label
        for="selectAll"
        class="tw-font-medium tw-text-gray-500 dark:tw-text-gray-300"
      >
        {{ "common.selectAll" | translate }}
      </label>
    </div>

    <div
      cdkDropList
      #todoList="cdkDropList"
      [cdkDropListData]="columnsList"
      class="tw-border dark:tw-border-dark-100 tw-rounded example-list"
      (cdkDropListDropped)="drop($event)"
    >
      @for (column of columnsList; track column; let last=$last; let
      first=$first) {
      <div
        class="tw-font-medium tw-w-[340px] example-box tw-px-3 tw-py-3 tw-border-b dark:tw-border-dark-100 tw-text-gray-500 tw-flex-between tw-cursor-move tw-text-base tw-bg-white dark:tw-bg-dark-500"
        cdkDrag
      >
        <!-- title -->
        <div class="tw-flex-center">
          <input
            (click)="hideColumn($event, column)"
            [value]="!column?.isHide"
            [checked]="!column?.isHide"
            class="form-check-input tw-ml-3 tw-mr-0 tw-pr-0 !tw-w-[18px] tw-mt-1 tw-cursor-pointer"
            type="checkbox"
          />
          <span class="dark:tw-text-gray-300">
            {{ column?.title | translate }}
          </span>
        </div>

        <!-- svg -->
        <span
          [inlineSVG]="'/assets/media/svg/icons/drag-svgrepo-com.svg'"
          class="svg-icon tw-opacity-70 svg-icon-2 tw-block svg-icon svg-icon-2 svg-icon-gray transform-180"
        ></span>
      </div>
      }
    </div>
  </div>
  <div
    class="tw-bg-white dark:tw-bg-dark-300 tw-bottom-0 tw-pb-5 tw-pl-3 tw-sticky tw-w-full"
  >
    <app-form-btns
      [loading]="loading"
      [showCloseBtn]="false"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </div>
</div>
